<template>

  <b-row>
    <b-col md="12">
      <b-card no-body :class="{ open: visibleBody }">
        <b-card-header 
          :class="{ collapsed: !visibleBody }" 
          :aria-expanded="visibleBody ? 'true' : 'false'" 
          role="tab"
          data-toggle="collapse" 
          @click="() => visibleBody = !visibleBody"
          style="padding: 1rem; background-color: #0080C9; color: white; font:45px; padding:15px;  ">
          <span class="lead collapse-title">
            <strong>DESCANSO MEDICO</strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" />
        </b-card-header>
        <b-collapse v-model="visibleBody" role="tabpanel">
          <b-card-body style="padding:1.5rem">

            <b-card v-if ="!eliminarDescanso" style="border: 1px solid #c9c9c9">

              <b-row class="my-1 d-flex align-items-center">
                <h5 class="col-4">Días de descanso:</h5>
                <b-form-input class="col-2 ml-1" v-model="descanso.diasDescanso" min="0" />
              </b-row>

              <b-row class="my-1 d-flex align-items-center">
                <h5 class="col-4">Aislamiento:</h5>

                <v-select 
                  class="col-5" 
                  placeholder="Seleccione una opcion" 
                  :options="aislamientoOpts"
                  :reduce="option => option" 
                  label="text" 
                  v-model="descanso.tipoAislamiento" 
                />
              </b-row>


              <b-row class="my-1 mt-3 d-flex align-items-center">
                <h5 class="col-4">Actividad laboral:</h5>
                <b-form-input 
                  class="col-7 ml-1" 
                  placeholder="Actividad laboral del paciente" 
                  rows="1" 
                  no-resize
                  v-model="descanso.actividadLaboral" 
                  id="actividadlab" 
                />
              </b-row>

              <b-row class="my-1 d-flex align-items-center">
                <h5 class="col-4">Empresa:</h5>
                <b-form-input 
                  class="col-7 ml-1" 
                  placeholder="" 
                  rows="1" 
                  no-resize 
                  v-model="descanso.empresa"
                  id="actividadlab" />
              </b-row>

              <b-row class="my-1 d-flex align-items-center">
                <h5 class="col-4">Dirección:</h5>
                <b-form-input 
                  class="col-7 ml-1" 
                  placeholder="" 
                  rows="1" 
                  no-resize
                  v-model="descanso.direccion" id="direccion" 
                />
              </b-row>

              <b-row class="my-3">
                <h5 class="col-12">Observación/Descanso:</h5>
                <b-form-textarea 
                  class="col mx-1" 
                  placeholder="Coloque las observaciones que deberá seguir" 
                  rows="1"
                  v-model="descanso.observacion" no-resize />
              </b-row>

              <b-row class="my-1 d-flex align-items-center">
                <h5 class="col-4">Tipo de contingencia: {{ descanso ? descanso.tipoContingencia ? descanso.tipoContingencia.text : '' : '' }}</h5>
                <v-select 
                  class="col-5" id="v-type-insurance" 
                  v-model="descanso.tipoContingencia"
                  placeholder="Seleccione contingencia" 
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="tipoContingenciaOpts" label="text" 
                />
              </b-row>

           
            </b-card>
            <b-row class="my-2 mt-3">
              <b-col class="text-right">
                <b-button v-if="descanso.estado === '1'" class="px-3 py-1" variant="primary" @click="guardarDescanso">
                  Guardar
                </b-button>
              </b-col>
              <b-col v-if="eliminarDescanso" class="text-right">
                <b-button class="px-3 py-1" variant="primary" @click="crearDescanso">
                  Agregar descanso
                </b-button>
              </b-col>
              <b-col class="text-right">
                <b-button   v-if="descanso && descanso.idDescanso && !eliminarDescanso && descanso.estado === '1'" class="px-3 py-1" variant="danger" @click="removerDescanso">
                  Eliminar descanso
                </b-button>
              </b-col>
            </b-row>

          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>


</template>

<script>
import { addNewOpt } from '@/shared/helpers';
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapState } from 'vuex';

export default {

  name: "DescansoMedico",

  components: {
    ToastificationContent,
    vSelect,
  },

  data() {
    return {

      visibleBody: false,
      eliminarDescanso:false,
      guardoNuevo:false,
      descanso: {
        estado: "1",
        diasDescanso: 0,
        tipoDiagnostico:null,
        tipoAislamiento:{ "text": "Ninguno", "value": 1 },
        actividadLaboral:null,
        empresa:null,
        direccion:null,
        observacion:'',
        tipoContingencia: null,
        idDescanso:null
      },

      diagnosticoOpts: [
        { text: "Definitivo", value: 1 },
        { text: "Presuntivo", value: 2 },
      ],

      aislamientoOpts: [
        { text: "Ninguno", value: 1 },
        { text: "Aislamiento", value: 2 },
        { text: "Teletrabajo", value: 3 },
      ],

      tipoContingenciaOpts: [
        { text: "Enfermedad General", value: 1 },
        { text: "Accidente Común", value: 2 },
        { text: "Enfermedad Profesional", value: 3 },
        { text: "Accidente de Trabajo", value: 4 },
        { text: "Maternidad y Paternidad", value: 5 },
        { text: "Riesgo durante el Embarazo o la Lactancia", value: 6 },
        { text: "Intervenciones Quirúrgicas", value: 7 },
      ],

    };
  },
  created() {
    this.residencia = this.direccionId
  },

  methods: {
    crearDescanso(){
      this.eliminarDescanso = false
      this.descanso.estado = '1'
    },


    async removerDescanso(){
      this.eliminarDescanso = true
      this.descanso.estado = '0'
      await this.guardarDescanso('0')
      localStorage.setItem('descanso', JSON.stringify(this.descanso));
    },


    onAddNewOpt(newArray) {
      return addNewOpt(newArray);
    },
    messageError(){
      if(!this.descanso.diasDescanso || !this.descanso.tipoAislamiento || !this.descanso.actividadLaboral 
      ||!this.descanso.empresa || !this.descanso.direccion ||!this.descanso.observacion || !this.descanso.tipoContingencia  ) {
        return true 
      } else { return false}
    },


    async guardarDescanso(accion) {
      this.guardoNuevo = true
      if (accion !== '0' && this.messageError()) {
        await this.$swal.fire({
          icon: 'error',
          text: 'Debe ingresar datos en todos los campos del formulario de descanso.'
        })
        return
      }

      const {
        diasDescanso, tipoDiagnostico, tipoAislamiento,
        actividadLaboral, empresa, tipoContingencia,
        observacion, estado, direccion, idDescanso
      } = this.descanso

      const tipoDiagnosticoValue = tipoDiagnostico
        ? this.descanso.tipoDiagnostico.value.toString()
        : null;

      const tipoAislamientoValue = tipoAislamiento
        ? this.descanso.tipoAislamiento.value.toString()
        : null;
      
      
      const contingencia = JSON.stringify(tipoContingencia)
      
      const newItem = {
        idDescanso:idDescanso ? idDescanso : '0',
        diasdescanso: parseInt(diasDescanso),
        tipodiagnostico: tipoDiagnosticoValue,
        aislamiento: tipoAislamientoValue,
        actividadlab: actividadLaboral,
        empresa: empresa,
        residenciaId: this.stResidencia.id,
        observacion: observacion,
        direccion : direccion,
        contingencia: contingencia,
        estado: estado,
      };
      
      if (accion === '0') {
        newItem.estado = accion
      }

      const descansoList = [newItem];
      
      this.$store.commit("setDescanso", descansoList);
      if(accion !== '0') {
        await this.$swal.fire({
          icon: 'success',
          text: 'Descanso guardado temporalmente.'
        })
      }
    },
  },

  watch: {
    stDescanso: {
      deep: true,
      handler(newValue) {
        try {
        
          if (newValue && newValue.estado === '1'){
            let desc = newValue

            let diagnostico = desc.tipodiagnostico
            let aislamiento = desc.aislamiento
            let d = parseInt(diagnostico, 10)
            let a = parseInt(aislamiento, 10)
            this.aislamientoOpts.forEach(item => {
              if (item.value === a) {
                aislamiento = item
              }
            })
            this.diagnosticoOpts.forEach(item => {
              if (item.value === d) {
                diagnostico = item
              }
            })
        
        
            let contingencia = desc.contingencia
            if (this.guardoNuevo) {
              contingencia = JSON.parse(desc.contingencia)
            }
            this.descanso.diasDescanso     = desc.diasdescanso;
            this.descanso.tipoDiagnostico  = diagnostico;
            this.descanso.tipoAislamiento  = aislamiento;
            this.descanso.actividadLaboral = desc.actividadlab
            this.descanso.empresa          = desc.empresa
            this.descanso.tipoContingencia = contingencia
            this.descanso.observacion      = desc.observacion
            this.descanso.estado           = desc.estado
            this.descanso.direccion        = desc.direccion
            this.descanso.idDescanso       = desc.idDescanso


            const newItem = {
              idDescanso      : this.descanso.idDescanso,
              diasdescanso    : parseInt(this.descanso.diasDescanso),
              tipodiagnostico : parseInt(desc.tipoDiagnostico),
              aislamiento     : parseInt(desc.aislamiento),
              actividadlab    : desc.actividadlab,
              empresa         : desc.empresa,
              residenciaId    : this.stResidencia.id,
              direccion       : desc.direccion,
              observacion     : desc.observacion,
              contingencia    : desc.contingencia,
              estado          : desc.estado,
            };

            const descansoList = [newItem]
            
            localStorage.setItem('descanso', JSON.stringify(descansoList));
          } else {
            this.descanso.idDescanso = newValue?.idDescanso
          }
        } catch (error){
          console.error("error en la traida de descanso", error)
        }
      }
    }
  },

  computed: {
    ...mapState({
      stResidencia: state => state.atencionCita.dataCita?.paciente.persona.residencia,
      stDescanso: state => {
        return state.atencionCita?.descanso?.descanso && state.atencionCita.descanso.descanso.length > 0 
          ? state.atencionCita.descanso.descanso[0] 
          : null; 
      }
    }),
  },

};
</script>
